import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { Routes } from '@angular/router';
import { NavigationService } from '../services/navigation.service';

import { SolApp } from '../models/sol-navigation';

export function provideSolNavigation(
  apps: SolApp[],
  routes: Routes,
  variables: Record<string, any>,
): (EnvironmentProviders | Provider)[] {
  return [
    provideAppInitializer(() => {
      const navigationService = inject(NavigationService);
      navigationService.initialize(apps, routes, variables);
    }),
  ];
}
